import { Wrench } from "lucide-react";

export default function DeactivatedNotice({ company }) {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6" data-testid="deactivated-notice">
      <div className="max-w-md text-center bg-white rounded-3xl shadow-sm border border-slate-100 p-10">
        <div className="w-14 h-14 mx-auto rounded-2xl bg-indigo-50 flex items-center justify-center mb-5">
          <Wrench className="w-7 h-7 text-indigo-600" />
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-2">{company || "Diese Seite"} ist vorübergehend nicht verfügbar</h1>
        <p className="text-slate-500 text-sm leading-relaxed">Die Webseite wird gerade überarbeitet oder wurde pausiert. Bitte versuche es später erneut.</p>
      </div>
    </div>
  );
}
